import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import type { Locale } from '../types';
import { SUPPORTED_LOCALES, LOCALE_LABELS } from '../types';

export function useLocale() {
  const { i18n, t } = useTranslation();

  const locale = (i18n.language || 'en-US') as Locale;

  const setLocale = useCallback(
    (newLocale: Locale) => {
      i18n.changeLanguage(newLocale);
    },
    [i18n]
  );

  return {
    locale,
    setLocale,
    t,
    supportedLocales: SUPPORTED_LOCALES,
    localeLabels: LOCALE_LABELS,
  };
}
